import { Injectable } from "@angular/core";
import { ObjectUtil } from "../../../components/common/object-util/object-util";

/**
 * Service performs cleanup of template data before saving
 * (by removing unnecessary properties used in template lifetime)
 */
@Injectable()
export class ReportDesignerTemplatePersistanceService {

  /**
   *  Cleanup of template data to be saved
   * @param templateObj
   * @returns
   */
  public getTemplateStringForSave(templateObj): any {
    const cleanedClone = this.getDataForSaveTemplate(templateObj);
    return JSON.stringify(cleanedClone, this.replacerForSaveTemplate);
  }

  /**
   * Replacer value for saving templates
   * @param key
   * @param value
   * @returns
   */
  private replacerForSaveTemplate(key, value) {
    //skip some properties when saving template
    if (key === "instance"
      || key === "dataLoaded"
      || key === "dataSaved"
      || key === "$$hashKey"
      || key === "api"
      || key === "waitingForPrint"
      || key === "isVirtualPageMaster") {
      return undefined;
    }

    return value;
  }

  /**
   * Gets the data for saving a template
   * @param templateObj
   * @returns
   */
  private getDataForSaveTemplate(templateObj): any {
    //clone template object and remove unnecessary properties (like virtual pages)
    const clone = ObjectUtil.deepCopy(templateObj);
    clone.pages = clone.pages || [];
    clone.pages = clone.pages.filter((page) => {
      return !page.isVirtualPage;
    });

    return clone;
  }
}
